document.addEventListener("DOMContentLoaded", async function () {
    console.log("✅ Script per il pulsante di scorrimento avviato!");

    var flickityElem = document.querySelector("flickity-carousel");
    if (!flickityElem) {
        console.log("❌ Flickity non trovato!");
        return;
    }

    var flickityInstance = await flickityElem.flickityInstance;
    if (!flickityInstance) {
        console.log("❌ Flickity non inizializzato correttamente.");
        return;
    }

    var thumbnailList = document.querySelector(".product__thumbnail-list-inner");

    if (!thumbnailList) {
        console.log("❌ Lista delle miniature non trovata!");
        return;
    }

    // 🔽 Crea il pulsante
    var scrollButtonContainer = document.createElement("div");
    scrollButtonContainer.id = "scroll-button-container";
    scrollButtonContainer.classList.add("custom-scroll-button-container");

    var nextButton = document.createElement("button");
    nextButton.id = "next-slide-btn";
    nextButton.classList.add("custom-scroll-button");

    var arrow = document.createElement("span");
    arrow.classList.add("arrow-down");

    nextButton.appendChild(arrow);
    scrollButtonContainer.appendChild(nextButton);

    // 🔽 Inserisce il pulsante nel DOM sotto la lista delle immagini
    document.body.appendChild(scrollButtonContainer);

    function updateButtonPosition() {
        let thumbnailListWrapper = document.querySelector(".product__thumbnail-list");
        if (!thumbnailListWrapper) {
            console.log("❌ Contenitore delle miniature non trovato!");
            return;
        }

        // 🔽 Nasconde il pulsante se la finestra è più piccola di 768px
        if (window.innerWidth <= 768) {
            scrollButtonContainer.style.display = "none";
            return;
        } else {
            scrollButtonContainer.style.display = "block";
        }

        let rect = thumbnailListWrapper.getBoundingClientRect();
        
        // 🔽 Imposta il pulsante sotto la lista
        scrollButtonContainer.style.position = "absolute";
        scrollButtonContainer.style.top = `${rect.bottom + window.scrollY + 10}px`;
        scrollButtonContainer.style.left = `${rect.left}px`;
        scrollButtonContainer.style.width = `${rect.width}px`;
        scrollButtonContainer.style.height = `40px`;
    }

    // 🔽 Aggiunge l'evento di resize per nascondere il pulsante quando la finestra è piccola
    window.addEventListener("resize", updateButtonPosition);
    setTimeout(updateButtonPosition, 500);

    flickityInstance.on("change", updateButtonPosition);
    updateButtonPosition(); // Posiziona il pulsante all'inizio

    // 🔽 Aggiunge l'evento di click per scorrere le immagini
    nextButton.addEventListener("click", function () {
        flickityInstance.next();
    });

    console.log("✅ Pulsante di scorrimento aggiunto e funzionante!");
});
